/**
 * DetailsDisclosure
 *
 * Wraps a <details> element and animates its open/close via height transitions.
 * Adapted from Advance Watch theme.
 */
class DetailsDisclosure extends HTMLElement {
    connectedCallback() {
        this.disclosure = this.querySelector('details');
        this.toggle = this.querySelector('summary');
        if (!this.disclosure || !this.toggle) return;

        this.panel = this.toggle.nextElementSibling;
        if (!this.panel) return;

        if (window.getComputedStyle(this.panel).transitionDuration !== '0s') {
            this._handleToggle = this._onToggle.bind(this);
            this._handleTransitionEnd = this._onTransitionEnd.bind(this);
            this.toggle.addEventListener('click', this._handleToggle);
            this.disclosure.addEventListener('transitionend', this._handleTransitionEnd);
        }
    }

    disconnectedCallback() {
        if (this.toggle && this._handleToggle) {
            this.toggle.removeEventListener('click', this._handleToggle);
        }
        if (this.disclosure && this._handleTransitionEnd) {
            this.disclosure.removeEventListener('transitionend', this._handleTransitionEnd);
        }
    }

    _onToggle(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.disclosure.open ? this.close() : this.open();
    }

    _onTransitionEnd(evt) {
        if (evt.target !== this.panel) return;
        if (this.disclosure.classList.contains('is-closing')) {
            this.disclosure.classList.remove('is-closing');
            this.disclosure.open = false;
        }
        this.panel.removeAttribute('style');
    }

    open() {
        this.panel.style.height = '0';
        this.disclosure.open = true;
        this.panel.style.height = `${this.panel.scrollHeight}px`;
    }

    close() {
        if (this.disclosure.classList.contains('is-closing')) return;
        this.panel.style.height = `${this.panel.scrollHeight}px`;
        this.disclosure.classList.add('is-closing');
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.panel.style.height = '0';
            });
        });
    }
}

customElements.define('details-disclosure', DetailsDisclosure);
